module.exports = __webpack_public_path__ + "2de9ceb3be872e5660117e16b86ea092.png";